import React, { useState } from 'react'
import { postObtenerFormasFarmaceuticasViasAplicacion } from '../../../services/ApiSuministros'
import Loading from '../../Loading'

const ModalConsultarFormasFarmaceuticas = ({setmodalOnConsultarFormasFarmaceuticas, dataUnaFormaFarmaceutica}) => {
    const [loading, setloading]=useState(true)
    const [dataViasAplicacion, setdataViasAplicacion]=useState([])
    const handleCancelarClick=()=>{
        setmodalOnConsultarFormasFarmaceuticas(false)
    }

    useState(()=>{
        const buscar={
            'FrmCod':dataUnaFormaFarmaceutica.FrmCod
        }
        setloading(false)
        postObtenerFormasFarmaceuticasViasAplicacion(buscar).then((res)=>{
          setloading(true)
            if(res.data.data){
                setdataViasAplicacion(res.data.data)
            }
        })
    },[])
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%-3rem)] max-w-5xl  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">        
    <h5
      className="text-xl font-medium leading-normal text-white"
      id="exampleModalScrollableLabel"
    >
     Consultar Formas Farmaceuticas
    </h5>  
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative">
              <div className="flex">                
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código Forma
                  </label>
                  <input
                  defaultValue={dataUnaFormaFarmaceutica.FrmCod}
                    disabled={true}                
                    name='codigo'
                    autoComplete="off"
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  
                </div>
                
                
              </div>
              <div className="flex my-2">
              
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción Forma
                  </label>
                  <input
                    //onChange={handleChangePalabraClave}
                    defaultValue={dataUnaFormaFarmaceutica.FrmDsc}
                    disabled={true}
                    name='palabraClave'             
                    autoComplete="off"
                    type="text" 
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
                </div>
              </div> 
              <div className="flex flex-col">
          <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-auto md:overflow-visible">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                      <th></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 bg-gray-200"
                      >                        
                      </th>         
                      
                                
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Código 
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Descripción 
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Orden 
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Sexo Aplicación 
                      </th>
                             
                    </tr>
                  </thead>
                  <tbody >
                    {
                      loading?
                        dataViasAplicacion.map((item, index)=>(
                            <tr className=" divide-y divide-slate-700 " key={index}>
                                <td></td>
                                <td></td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                    {item.FrmCod}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left"> 
                                    {item.ViAplDSc}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                    {item.ViAplOrd}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                    {item.ViAplSex === 'A'? 'Ambos':null}
                                    {item.ViAplSex === 'F'? 'Femenino':null}
                                    {item.ViAplSex === 'M'? 'Masculino':null}
                                </td>
                            </tr>
                        ))
                        :
                        <tr className="divide-y divide-slate-700 ">
                        <td></td>
                        <td></td>   
                        <td></td>                     
                        <td>
                          <Loading />
                        </td>
                        <td></td>    
                        <td></td>                    
                      </tr>
                    }
                   </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
          
        </div>
        
        
      </div>
    </div>    
   
    
  </div>
  )
}

export default ModalConsultarFormasFarmaceuticas